var Checkout = {
  init: function(deliveryDateTimesByPartnerAndDate) {
    $('.cart')
      .on('click', '.add, .subtract', function(event) {
        ItemForm.updateItemQuantityInputValue(event)
      })
      .on('click', '.delete', this.removeItem)
      .on('change', '[name="quantity"]', function(event) {
        Checkout.updateItemQuantity(event);
      });

    $('.remove-credit-card').on('click', this._removeCreditCard);

    $('.delivery-radio').on('click', this.updateDeliveryFee);
    $('.delivery-date').on('change', this._renderPossibleDeliveryTimes.bind(this, deliveryDateTimesByPartnerAndDate)).trigger('change');
    $('.delivery-terminal').on('change', this.updateDeliveryFee);

    $('[name=paymentMethod]').on('change', this._changePaymentMethod).trigger('change');

    $('#tosCheck').on('change', this._changeTosCheck);

    $('#confirm').click(function () {
      if(Checkout._validateForm()) {
        this.disabled = true;
        this.form.submit();
      }
    });

    // todo: enable DKK functionality - uncomment
    /* $('#confirm').click(function () {
      if(Checkout._validateForm()) {
        var confirmModal = $('#confirmEmailDigitalProduct');
        if (confirmModal.length) {
          Checkout._setEmailForEmailDigitalProductModal();
          confirmModal.show();
        } else {
          this.disabled = true;
          this.form.submit();
        }
      }
    });

    $('#backButton').click(function () {
      $('#confirmEmailDigitalProduct').hide();
    });

    $('#backButton2').click(function () {
      $('#confirmEmailDigitalProduct').hide();
      if ($('#recipient-email').val().length > 0) {
        $('#recipient-email').focus();
      } else {
        $('#email').focus();
      }
    });

     */

    $('#confrimEmail').click(function () {
      if(Checkout._validateForm()) {
        this.disabled = true;
        this.form.submit();
      }
    });

    this._prefillPickupTimes();
  },

  _setEmailForEmailDigitalProductModal: function () {
    var email = $('#email').val();
    if ($('#recipient-email').val().length > 0) {
      email = $('#recipient-email').val();
    }
    $('#digitalProductEmail').text(email);
  },

  _checkInvoiceData: function (){
    var nameEmpty = $('#business-name').val() === "";
    var addressEmpty = $('#business-address').val() === "";
    var regEmpty = $('#business-registry-code').val() === "";
    var isEmpty = nameEmpty || addressEmpty || regEmpty;
    return {
      hasEmpty: isEmpty,
      fields: ["business-name", "business-address", "business-registry-code"],
      values: [nameEmpty, addressEmpty, regEmpty]
    };
  },

  _validateForm: function(){
    if($('#payment-method-invoice').is(':checked')) {
      var invoice_data = Checkout._checkInvoiceData();
      if(invoice_data.hasEmpty) {
        for(var i = 0; i < invoice_data.fields.length; i++) {
          if (invoice_data.values[i])
            $('#' + invoice_data.fields[i]).addClass("is-invalid");
          else
            $('#' + invoice_data.fields[i]).removeClass("is-invalid");
        }
        $("body,html").animate({
              scrollTop: $("#businessClientInfo").offset().top
            },
            300 //speed
        );
        return false;
      }
    }
    return true;
  },

  _changePaymentMethod: function() {
    $('#payment-method-invoice-warning').toggle($('#payment-method-invoice').is(':checked'));
    if($('#payment-method-invoice').is(':checked')){
      $('#businessClientInfo').collapse('show');
      $('#businessClientInfoToggler').collapse('hide');
    }

    Checkout.togglePayButtonActivation();

    $('#summary-giftcard').toggle($('#payment-method-giftcard').is(':checked')); // todo: enable DKK functionality - replace with payment-method-digitalGiftcard
    $('#payment-method-giftcard-warning').toggle($('#payment-method-giftcard').is(':checked'));
    $('#payment-method-digital-giftcard-warning').toggle($('#payment-method-digitalGiftcard').is(':checked'));
    $('#payment-method-creditCard-options').toggle($('#payment-method-creditCard').is(':checked'));
  },

  _changeTosCheck: function () {
    Checkout.togglePayButtonActivation();
  },

  togglePayButtonActivation: function() {
    var totalAmountText = $('#total-amount').text();
    var totalAmount = parseFloat(totalAmountText.substr(0, totalAmountText.length - 2).replace(',','.'));

    if ($('#tosCheck').prop('checked')
        //&& !$('#payment-method-giftcard').is(':checked') todo: enable DKK functionality - uncomment
        //&& !($('#payment-method-digitalGiftcard').is(':checked') && totalAmount !== 0)
        //&& !(!$('#payment-method-digitalGiftcard').is(':checked') && totalAmount === 0)
        ) {
      $('#confirm').prop('disabled', false);
    } else {
      $('#confirm').prop('disabled', true);
    }
  },

  _removeCreditCard: function() {
    var creditCard = $(this).closest('.custom-radio');
    var creditCardId = creditCard.find('input').val();
    $.ajax('/account/creditcard/' + creditCardId + '/', {
      type: 'DELETE'
    }).done(function() {
      creditCard.remove();
    });
    return false;
  },

  _prefillPickupTimes: function() {
    $(".pickup-date").each(function() {
      var preselectedPickupTime = $(this).data("initial-selected-delivery-time");
      var pickupTimeSelect = $(this).closest(".custom-radio").find(".delivery-time");
      var preselectedPickupTimeIsSet = preselectedPickupTime.length;
      var preselectedPickupTimeIsAvailable = pickupTimeSelect.find("option[value='" + preselectedPickupTime + "']").length;
      if (preselectedPickupTimeIsSet && preselectedPickupTimeIsAvailable) {
        pickupTimeSelect.val(preselectedPickupTime);
      }
    })
  },

  _renderPossibleDeliveryTimes: function(deliveryDateTimesByPartnerAndDate, event) {
    var dateSelect = $(event.target);

    var container = dateSelect.parent().parent().parent().find(".delivery-times");

    var deliveryTimes = container.find(".delivery-time")

    deliveryTimes.toArray().forEach(function(time) {
        if ($(time).data("date") === dateSelect.val()) {
            Checkout.toggleOption($(time), true);
        } else {
            Checkout.toggleOption($(time), false);
        };
    });

  },

  toggleOption: function( element, show ) {
      jQuery( element ).toggle( show );
      if( show ) {
          if( jQuery( element ).parent( 'span.toggleOption' ).length )
              jQuery( element ).unwrap( );
      } else {
          if( jQuery( element ).parent( 'span.toggleOption' ).length == 0 )
              jQuery( element ).wrap( '<span class="toggleOption" style="display: none;" />' );
      }

  },

  _reloadPageIfLastItemRemoved: function(response) {
    if (response.cartItemsCount == 0)
      Checkout._reloadWindow();
  },

  _reloadWindow: function() {
    window.location.reload();
  },

  removeItem: function(event) {
    event.preventDefault();
    if ($(event.target).attr('disabled')) return;
    $(event.target).attr('disabled', true);

    var cartItemRow = $(event.target).closest('.cart-item-row');
    var itemId = cartItemRow.data("item-id");
    var partnerId = cartItemRow.data("partner-id");

    $.post('/checkout/' + itemId + '/remove/', {
      'selectedDeliveryChannels[]': Checkout.selectedDeliveryChannelsRemoving(partnerId)
    })
      .done(function() {
        cartItemRow.remove()
      })
      .done(Checkout._reloadPageIfLastItemRemoved)
      .done(Checkout._removePartnerWithoutItemsInCart)
      .done(Checkout._updatePill)
      .done(Checkout.updateDeliveryAndTotalPrices)
      .done(Checkout.updateDeliveryFee);
  },

  updateDeliveryFee: function() {
    var selectedDeliveryChannels = $('.delivery-radio:checked');

    var partnerchannels = Checkout.selectedDeliveryChannels();
    var selectedterminals = Checkout.selectedTerminals();

    if (selectedDeliveryChannels.length > 0) {
      $.post('/checkout/update-delivery-fee/', {
        'selectedDeliveryChannels[]': partnerchannels,
        'selectedTerminals[]': selectedterminals
      }).done(function(data) {
        Checkout.updateDeliveryAndTotalPrices(data)
      });

      var channelIds = Checkout.selectedDeliveryChannelIds();



      $(".selected-channel-details").toArray().forEach(function(channel) {
        var chan = $(channel).data("id").toString();
        var cc_chan = $(channel).data("ccid");
        $(channel).toggle(channelIds.includes(chan) || partnerchannels.includes(cc_chan));
      });
    }
  },

  selectedDeliveryChannels: function() {
    return $('.delivery-radio:checked').map(function () {
      return $(this).data('partner-delivery-channel-id')
    }).toArray();
  },

  selectedDeliveryChannelsRemoving: function(removingPartnerId) {
    var channels;

    if ($('tr.cart-item-row[data-partner-id=' + removingPartnerId + ']').size() > 1) {
      channels = $('.delivery-radio:checked').map(function() {
        return $(this).data('partner-delivery-channel-id')
      }).toArray();
    } else {
      channels = $('.delivery-radio:not([name="delivery-channel[' + removingPartnerId + ']"]):checked').map(function() {
        return $(this).data('partner-delivery-channel-id')
      }).toArray();
    }

    return channels;
  },

  selectedDeliveryChannelIds: function() {
    return $('.delivery-radio:checked').map(function () {
      return $(this)[0].value;
    }).toArray();
  },

  selectedTerminals: function() {
    return $('.delivery-terminal').map(function () {
      return $(this).val()
    }).toArray();
  },

  updateDeliveryAndTotalPrices: function(response) {
    Checkout.updateDeliveryChannelFees(response.checkout.deliveryChannelFees);
    $('#items-total').text(response.checkout.totalItemsAmount);
    $('#delivery-fee').text(response.checkout.totalDeliveryFee);
    $('#vat-amount').text(response.checkout.totalVATAmount);
    $('#total-amount').text(response.checkout.totalAmount);
    $('#summary tbody .giftcard').remove();
    $.each(response.checkout.giftcards, function(index, giftcard) {
      $('#summary tr#' + giftcard.code + " td.text-right").text(giftcard.amount)
    });
  },

  updateDeliveryChannelFees: function(partnerDeliveryChannelFees) {
    Object.keys(partnerDeliveryChannelFees).forEach(function(partnerDeliveryChannelId) {
      $('[data-partner-delivery-fee-id="' + partnerDeliveryChannelId + '"]').text(partnerDeliveryChannelFees[partnerDeliveryChannelId])
    })
  },

  updateItemQuantity: function(event) {
    ItemForm.sanitizeQuantity(event);
    var quantityInputElement = event.target;
    var itemId = $(quantityInputElement).closest('tr').data("item-id");
    $.post('/checkout/' + itemId + '/update/' + $(quantityInputElement).val() + '/', {
      'selectedDeliveryChannels[]': Checkout.selectedDeliveryChannels(),
      'selectedTerminals[]': Checkout.selectedTerminals()
    }).done(function(response) {
      Checkout._handleQuantityResponse(response, itemId)
    });
  },


  _handleQuantityResponse: function(response, itemId) {
    $('#item-extended-price-' + itemId).text(response.extendedPrice);
    var hasError = response.hasOwnProperty('error');
    $('.cart-error').toggleClass('hidden', !hasError);
    $('.alert-danger').text(response.error);
    $('#quantity-' + itemId).val(response.itemQuantity);
    Checkout.updateDeliveryAndTotalPrices(response);
  },

  _updatePill: function(response) {
    var pill = $('.js-cart-indicator')
      .removeClass('pulse')
      .text(response.cartItemsCount);

    setTimeout(function() {
      pill.addClass('pulse')
    }, 0);
  },

  _removePartnerWithoutItemsInCart: function(response) {
    if (response.numberOfPartnerItemsInCart == 0) {
      Checkout._removePartnerDeliveryOptions(response.partnerId);
    }
  },

  _removePartnerDeliveryOptions: function(partnerId) {
    var selectedDeliveryChannelId = $('#step-delivery').find('.partner-deliveries[data-partner-id="' + partnerId + '"]').find('input[type=radio]:checked').val();
    if (!$('#step-delivery').find('.partner-deliveries').not('[data-partner-id="' + partnerId + '"]').find('input[value=' + selectedDeliveryChannelId + ']:checked').length) {
      Checkout._removeDeliveryChannelDetails(selectedDeliveryChannelId);
    }
    $('#step-delivery').find('.partner-deliveries[data-partner-id="' + partnerId + '"]').remove();
  },

  _removeDeliveryChannelDetails: function (channelId) {
    $('#step-delivery').find('#delivery-channel-details-' + channelId).remove();
  },

};